import { getTodayInTimeZone } from '../autopay-utils';

export function getTodayInCentralTime(): Date {
  return getTodayInTimeZone('America/Chicago');
}

export function createDateFromToday(daysOffset: number): Date {
  const date = getTodayInCentralTime();
  date.setDate(date.getDate() + daysOffset);
  return date;
}
